import { trpc, TrpcInputs, TrpcOutputs } from '../../config/trpc';

type UseAccountInvite = {
  createAccountInvite: (args: SendInviteInput) => Promise<SendInviteOutput>;
  isLoading: boolean;
  error?: string;
};

export type SendInviteInput = TrpcInputs['createAccountInvite'];
export type SendInviteOutput = TrpcOutputs['createAccountInvite'];

export const useAccountInvite = (): UseAccountInvite => {
  const { mutateAsync: createAccountInvite, isLoading, error } = trpc.createAccountInvite.useMutation();

  return { createAccountInvite, isLoading, error: error?.message };
};
